import React, { useContext } from "react";
import { 
  Card, 
  CardContent, 
  TextField, 
  Typography, 
  Grid,
  InputAdornment,
  Divider,
  Box
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { 
  LocalHospital as MedicalIcon,
  EventNote as DateIcon,
  Description as DocumentIcon,
  DirectionsCar as AccidentIcon
} from "@mui/icons-material";
import { Context } from "../../context";
import { MEDICAL_BILLING_PERSON } from "../../config";

const ConditionField = ({
  label,
  name,
  value,
  updateCondition,
  painConsultNoteSigned,
  icon,
  placeholder,
  type = "text"
}) => {
  const { user } = useContext(Context);
  
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      margin="dense"
      label={label}
      value={value || ""}
      name={name}
      onChange={(e) => updateCondition(e)}
      disabled={(user && user.role === MEDICAL_BILLING_PERSON) }
      placeholder={placeholder}
      type={type}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ) : null
      }}
    />
  );
};

const ConditionRelatedTo = ({
  conditionRelatedTo,
  setConditionRelatedTo,
  painConsultNoteSigned,
}) => {
  const { user } = useContext(Context);
  
  const updateConditionRelatedTo = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setConditionRelatedTo((values) => ({ ...values, [name]: value }));
  };

  const handleDateOfFirstVisitChange = (date) => {
    setConditionRelatedTo({
      ...conditionRelatedTo,
      date_of_first_visit: date,
    });
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <MedicalIcon sx={{ mr: 1 }} color="secondary" /> 
          Condition Related Information
        </Typography>
        
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ConditionField
              label="Accident Type"
              name="accident_type"
              value={conditionRelatedTo.accident_type}
              updateCondition={updateConditionRelatedTo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<AccidentIcon color="secondary" fontSize="small" />}
              placeholder="e.g. Auto, Work, Other"
            />
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                <DateIcon fontSize="small" color="secondary" sx={{ mr: 0.5 }} />
                Date of First Visit
              </Typography>
              <Box sx={{ pl: 3, pt: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    onChange={handleDateOfFirstVisitChange}
                    value={conditionRelatedTo.date_of_first_visit}
                    sx={{ width: '100%' }}
                    disabled={(user && user.role === MEDICAL_BILLING_PERSON) }
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: true,
                        placeholder: 'MM/DD/YYYY'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <ConditionField
              label="NF3 (1st Bill)"
              name="nf3"
              value={conditionRelatedTo.nf3}
              updateCondition={updateConditionRelatedTo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<DocumentIcon color="secondary" fontSize="small" />}
              placeholder="NF3 reference"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <ConditionField
              label="NF2"
              name="nf2"
              value={conditionRelatedTo.nf2}
              updateCondition={updateConditionRelatedTo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<DocumentIcon color="secondary" fontSize="small" />}
              placeholder="NF2 reference"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ConditionRelatedTo;